import {createAsyncThunk} from '@reduxjs/toolkit'
import {
  FetchPaymentCategoryByIdRequest,
  UpdatePaymentCategoryRequest,
  FetchPaymentCategoriesRequest,
  CreatePaymentCategoryRequest,
  DeletePaymentCategoryRequest,
  SuspendPaymentCategoryRequest,
  ActivatePaymentCategoryRequest,
  FetchAllPaymentCategoriesRequest
} from './types'
import {AxiosError} from 'axios'
import {ResponseError} from '../commonTypes'
import {PaymentCategory} from '../../../models'
import axios from 'axios'
import {
  fetchPaymentCategoriesUrl,
  fetchPaymentCategoryByIdUrl,
  createPaymentCategoryUrl,
  updatePaymentCategoryUrl,
  deletePaymentCategoryUrl,
  suspendPaymentCategoryUrl,
  activatePaymentCategoryUrl,
  fetchAllPaymentCategoriesUrl
} from '../../api'

export const fetchPaymentCategories = createAsyncThunk(
  'paymentCategory/fetch',
  async (payload: FetchPaymentCategoriesRequest, {rejectWithValue}) => {
    try {
      const res = await axios.get(
        `${fetchPaymentCategoriesUrl}?sortField=${payload.sortField}&sortOrder=${
          payload.sortOrder
        }&pageNumber=${payload.pageNumber}&pageCount=${payload.pageCount}${
          payload.search && payload.search.trim() !== '' ? '&search=' + payload.search.trim() : ''
        }`
      )
      const {paymentCategories, totalPages, total} = res.data
      return {
        paymentCategories,
        totalPages,
        total,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const fetchAllPaymentCategories = createAsyncThunk(
  'paymentCategory/fetchAll',
  async (payload: FetchAllPaymentCategoriesRequest, {rejectWithValue}) => {
    try {
      const res = await axios.get(
        `${fetchAllPaymentCategoriesUrl}`
      )
      const {paymentCategories} = res.data
      return {
        paymentCategories,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const fetchPaymentCategoryById = createAsyncThunk(
  'paymentCategory/fetchById',
  async (payload: FetchPaymentCategoryByIdRequest, {rejectWithValue}) => {
    try {
      const res = await axios.get(`${fetchPaymentCategoryByIdUrl}/${payload.id}`)
      const {paymentCategory} = res.data
      return {
        paymentCategory,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const createPaymentCategory = createAsyncThunk(
  'paymentCategory/create',
  async (payload: CreatePaymentCategoryRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(createPaymentCategoryUrl, payload)
      const {paymentCategory} = res.data
      return {
        paymentCategory,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const updatePaymentCategory = createAsyncThunk(
  'paymentCategory/update',
  async (payload: UpdatePaymentCategoryRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(updatePaymentCategoryUrl, payload)
      const {paymentCategory} = res.data
      return {
        paymentCategory,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const deletePaymentCategory = createAsyncThunk(
  'paymentCategory/delete',
  async (payload: DeletePaymentCategoryRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(deletePaymentCategoryUrl, payload)
      const {paymentCategory} = res.data
      return {
        paymentCategory,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const suspendPaymentCategory = createAsyncThunk(
  'paymentCategory/suspend',
  async (payload: SuspendPaymentCategoryRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(suspendPaymentCategoryUrl, payload)
      const {paymentCategory} = res.data
      return {
        paymentCategory,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const activatePaymentCategory = createAsyncThunk(
  'paymentCategory/activate',
  async (payload: ActivatePaymentCategoryRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(activatePaymentCategoryUrl, payload)
      const {paymentCategory} = res.data
      return {
        paymentCategory,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

